export const getInjuryBadge = player => {
  const rawLevel = player?.injuryLevel ?? player?.InjuryLevel
  const injuryLevel = Number(rawLevel)

  if (!Number.isFinite(injuryLevel) || injuryLevel < 0) {
    return null
  }

  if (injuryLevel === 0) {
    return {
      icon: '🩹',
      text: '🩹',
      title: 'Kolhiintunut 0 viikkoa',
    }
  }

  if (injuryLevel === 999) {
    return {
      icon: '❌',
      text: '❌ ∞',
      title: 'Loukkaantunut toistaiseksi',
    }
  }

  return {
    icon: '❌',
    text: `❌ ${injuryLevel}`,
    title: `Loukkaantunut ${injuryLevel} viikkoa`,
  }
}
